import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { RegistryComponentNames } from '@shared/constants/registry-component-name';
import { PipesModule } from '@shared/pipes/pipes.module';
import { ThumbnailUrlService } from '@shared/services/thumbnail-url.service';
import { ImagePreviewDialogService } from '../image-preview-dialog/image-preview-dialog.service';

@Component({
  selector: RegistryComponentNames.AssetPopupContent,
  templateUrl: './asset-popup-content.component.html',
  styleUrls: ['./asset-popup-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, TranslateModule, PipesModule],
})
/** This component currently is used as custom angular elemement. Before using, keep in mind that all input values
 * for custom elements are coming as stringified values.
 */
export class AssetPopupContentComponent implements OnInit {
  private thumbnailUrlService = inject(ThumbnailUrlService);
  private imgPreviewDialogService = inject(ImagePreviewDialogService);

  @Input() description: string;
  @Input() userName?: string;
  @Input() department?: string;
  @Input() currentLocation?: string;
  @Input() serial?: string;
  @Input() lastActivityTime?: string;
  @Input() documentThumbnail?: string;
  @Input() lastMoved?: string;
  @Input() temperature?: string;
  @Input() lat?: string;
  @Input() lng?: number;
  // asset id
  @Input() id: string;
  // entity id (used in fleet - meaning fleet entityId)
  @Input() entityId?: string;
  @Input() hasTemporaryGeofence?: 'true' | 'false' = 'false';
  @Input() documentId: string;

  assetImage: SafeResourceUrl | undefined;

  ngOnInit(): void {
    this.assetImage = this.documentThumbnail
      ? this.thumbnailUrlService.getSafeUrl(this.documentThumbnail)
      : undefined;
  }

  openImagePreview(): void {
    if (!this.documentId) return;

    this.imgPreviewDialogService.openFullImageDialog({
      attachmentId: Number(this.documentId),
    });
  }
}
